import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { systemAPI } from '../../utils/axios';
import * as S from './Login.style';

const Login = () => {
  const navigate = useNavigate();
  const { login, isLoading, error, clearError, isAuthenticated } = useAuthStore();
  
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [serverStatus, setServerStatus] = useState('checking'); // 'checking', 'online', 'offline'

  // 이미 로그인된 경우 메인 페이지로 리다이렉트
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/upload');
    }
  }, [isAuthenticated, navigate]);

  // 컴포넌트 마운트시 서버 상태 확인
  useEffect(() => {
    checkServerStatus();
  }, []);

  // 에러 클리어
  useEffect(() => {
    return () => {
      clearError();
    };
  }, [clearError]);

  const checkServerStatus = async () => {
    try {
      const result = await systemAPI.healthCheck();
      setServerStatus(result.success ? 'online' : 'offline');
    } catch (error) {
      console.error('[LOGIN]', 'Server health check failed:', error);
      setServerStatus('offline');
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // 입력 시 에러 클리어
    if (error) {
      clearError();
    }
  };

  const handleShowPasswordToggle = () => {
    setShowPassword(prev => !prev);
  };

  const handleRememberMeToggle = () => {
    setRememberMe(prev => !prev);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!formData.email.trim()) {
      return;
    }
    
    if (!formData.password.trim()) {
      return;
    }

    // 서버 상태 재확인
    if (serverStatus === 'offline') {
      await checkServerStatus();
      if (serverStatus === 'offline') {
        return;
      }
    }

    const result = await login(formData.email, formData.password);
    
    if (result.success) {
      navigate('/upload');
    }
  };

  const handleDemoLogin = async (userType) => {
    // 데모 계정을 실제 백엔드에 맞게 수정
    const demoCredentials = {
      admin: { email: 'admin@hospital.com', password: 'admin123' },
      user: { email: 'user@hospital.com', password: 'user123' }
    };

    const credentials = demoCredentials[userType];
    setFormData(credentials);
    
    const result = await login(credentials.email, credentials.password);
    if (result.success) {
      navigate('/upload');
    }
  };

  return (
    <S.LoginContainer>
      <S.LoginCard>
        <S.LoginHeader>
          <S.LoginTitle>로그인</S.LoginTitle>
          <S.LoginSubtitle>실태조사 관리시스템에 로그인하세요</S.LoginSubtitle>
          
          {/* 서버 상태 표시 */}
          {serverStatus === 'checking' && (
            <S.ServerStatus status="checking">
              서버 상태 확인 중...
            </S.ServerStatus>
          )}
          {serverStatus === 'offline' && (
            <S.ServerStatus status="offline">
              ⚠️ 서버에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.
              <S.RetryButton onClick={checkServerStatus}>
                다시 시도
              </S.RetryButton>
            </S.ServerStatus>
          )}
          {serverStatus === 'online' && (
            <S.ServerStatus status="online">
              ✅ 서버 연결 상태 양호
            </S.ServerStatus>
          )}
        </S.LoginHeader>

        <S.LoginForm onSubmit={handleSubmit}>
          <S.FormGroup>
            <S.FormLabel>이메일</S.FormLabel>
            <S.FormInput
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="이메일을 입력하세요"
              required
              hasError={!!error}
              disabled={serverStatus === 'offline'}
            />
          </S.FormGroup>

          <S.FormGroup>
            <S.FormLabel>비밀번호</S.FormLabel>
            <S.PasswordInputWrapper>
              <S.FormInput
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="비밀번호를 입력하세요"
                required
                hasError={!!error}
                disabled={serverStatus === 'offline'}
              />
              <S.PasswordToggle 
                type="button"
                onClick={handleShowPasswordToggle}
                disabled={serverStatus === 'offline'}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </S.PasswordToggle>
            </S.PasswordInputWrapper>
          </S.FormGroup>

          {error && (
            <S.ErrorMessage>
              {error}
            </S.ErrorMessage>
          )}

          {/* <S.FormOptions>
            <S.CheckboxWrapper>
              <S.Checkbox
                type="checkbox"
                checked={rememberMe}
                onChange={handleRememberMeToggle}
                disabled={serverStatus === 'offline'}
              />
              <S.CheckboxLabel>로그인 상태 유지</S.CheckboxLabel>
            </S.CheckboxWrapper>
            <S.ForgotPassword href="#" onClick={(e) => e.preventDefault()}>
              비밀번호를 잊으셨나요?
            </S.ForgotPassword>
          </S.FormOptions> */}

          <S.SubmitButton 
            type="submit" 
            disabled={isLoading || serverStatus === 'offline'}
          >
            {isLoading ? '로그인 중...' : '로그인'}
          </S.SubmitButton>
        </S.LoginForm>
{/* 
        <S.Divider>
          <S.DividerLine />
          <S.DividerText>또는</S.DividerText>
          <S.DividerLine />
        </S.Divider>

        <S.DemoSection>
          <S.DemoTitle>데모 계정으로 체험해보기</S.DemoTitle>
          <S.DemoButtons>
            <S.DemoButton 
              onClick={() => handleDemoLogin('admin')}
              disabled={isLoading || serverStatus === 'offline'}
            >
              관리자 계정
            </S.DemoButton>
            <S.DemoButton 
              onClick={() => handleDemoLogin('user')}
              disabled={isLoading || serverStatus === 'offline'}
            >
              일반 사용자 계정
            </S.DemoButton>
          </S.DemoButtons>
        </S.DemoSection> */}

        <S.SignupLink>
          계정이 없으신가요? <Link to="/register">회원가입</Link>
        </S.SignupLink>

          {/* <S.Logo>
            <S.LogoIcon>🏥</S.LogoIcon>
            <S.LogoText>한국병원약사회</S.LogoText>
          </S.Logo> */}
        {/* <S.LogoOption>
          <S.LogoImage src="/assets/logo-expanded.jpg" alt="Pivo Logo" />
        </S.LogoOption> */}

      </S.LoginCard>
    </S.LoginContainer>
  );
};

export default Login;